// extracted by mini-css-extract-plugin
export default {"label":"_3kz4eH5RrpnBbrfzlvcB55"};